import $ from 'jquery';
import BasePropertyView from 'BasePropertyView.js';
import _template from 'properties/table/column-style-border.ejs';
import { pickerCfg } from 'pickerCfg.js';
import util from 'util/Util.js';
import undoService from 'UndoService';
import textConstants from "../../../constants/TextConstants";

class StyleBorderView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;
        this.colId = this.model.get('selectedRowId');
        this.factoryKey = this.model.get('gridData')[this.colId].attributes['factoryKey'];

        this.events = {
            'change #borderColorText' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'change #cornerRadius, #borderStyle, #borderSize' : 'updateSelectAttributes',
            'change #borderColor' : 'updateColorPicker'
        };
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        const oldPropVal = this.model.get('gridData')[this.colId].attributes[propName];
        let color = propVal;

        if (util.isValidColorcode(propVal)) {
            color = this.resolveColor(propVal);
            // needs to set to the Column Name for this Column
            this.model.get('gridData')[this.colId].attributes[propName] = color;
            this.render();
        }
        this.render();

        // PF-3465 Undo/Redo for Border Attributes.
        undoService.add({
            undo: () =>{
                this.model.get('gridData')[this.colId].attributes[propName] = oldPropVal;
                this.render();
            },
            redo:() => {
                this.model.get('gridData')[this.colId].attributes[propName] = color;
                this.render();
            }
        },textConstants.UNDO_BORDER)

    }

    updateSelectAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        const oldPropVal = this.model.get('gridData')[this.colId].attributes[propName];

        // needs to set to the Column Name for this Column
        this.model.get('gridData')[this.colId].attributes[propName] = propVal;

        // PF-3465 Undo/Redo for Border Attributes.
        undoService.add({
            undo: () =>{
                this.model.get('gridData')[this.colId].attributes[propName] = oldPropVal;
            },
            redo:() => {
                this.model.get('gridData')[this.colId].attributes[propName] = propVal;
            }
        },textConstants.UNDO_BORDER_SELECTION)
    }

    updateColorPicker(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.id;
        const propVal  = ev.currentTarget.value;
        const oldPropVal = this.model.get('gridData')[this.colId].attributes[propName];

        var propTextName = propName + 'Text';
        $('#' + propTextName).val(propVal);
        // needs to set to the Column Name for this Column
        this.model.get('gridData')[this.colId].attributes[propTextName] = propVal;

        // PF-3465 Undo/Redo for Border ColorPicker.
        undoService.add({
            undo: () =>{
                this.model.get('gridData')[this.colId].attributes[propName] = oldPropVal;
                $('#' + propTextName).val(oldPropVal);
            },
            redo:() => {
                this.model.get('gridData')[this.colId].attributes[propName] = propVal;
                $('#' + propTextName).val(propVal);
            }
        },textConstants.UNDO_COLOR_BORDER)
    }

    render() {
        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));

        //set selected index to model value
        if(this.model.get('gridData')[this.colId].attributes['cornerRadius']) {
            $('#cornerRadius').find('option[value='+this.model.get('gridData')[this.colId].attributes['cornerRadius']+']').attr('selected', true);
        }

        if(this.model.get('gridData')[this.colId].attributes['borderSize']) {
            $('#borderSize').find('option[value='+this.model.get('gridData')[this.colId].attributes['borderSize']+']').attr('selected', true);
        }

        if(this.model.get('gridData')[this.colId].attributes['borderStyle']) {
            $('#borderStyle').find('option[value='+this.model.get('gridData')[this.colId].attributes['borderStyle']+']').attr('selected', true);
        }

        this.delegateEvents();

        return this;
    }



}

export default StyleBorderView;